{
  "name": "@mui/toolpad-app",
  "version": "0.1.20",
  "license": "MIT",
  "scripts": {
    "build": "concurrently \"yarn:build:*\" && rimraf ./.next/cache",
    "start": "next start",
    "dev": "concurrently \"yarn:dev:*\"",
    "cli": "./cli.js",
    "lint": "next lint && prettier --check .",
    "fix": "next lint --fix && prettier --write .",
    "build:cli": "tsup",
    "build:editor": "vite build ./src/toolpad",
    "build:next": "cross-env NODE_OPTIONS=--max-old-space-size=8192 next build",
    "build:typings": "tsx ./scripts/typings.mts",
    "dev:cli": "tsup --watch",
    "dev:typings": "yarn build:typings",
    "waitForApp": "tsx ./scripts/waitForApp.mts",
    "check-types": "tsup && tsc --noEmit",
    "test": "jest"
  },
  "files": [
    "public",
    "scripts",
    "dist",
    "cli.js",
    ".next"
  ],
  "exports": {
    "./package.json": "./package.json",
    "./cli": {
      "require": "./dist/cli/index.js"
    },
    "./*": {
      "types": "./dist/exports/*.d.ts",
      "import": "./dist/exports/*.mjs",
      "require": "./dist/exports/*.js"
    }
  },
  "dependencies": {
    "@emotion/cache": "11.11.0",
    "@emotion/react": "11.11.1",
    "@emotion/server": "11.11.0",
    "@emotion/styled": "11.11.0",
    "@googleapis/drive": "6.0.0",
    "@googleapis/sheets": "5.0.0",
    "@mui/icons-material": "5.13.7",
    "@mui/lab": "5.0.0-alpha.135",
    "@mui/material": "5.13.7",
    "@mui/system": "5.13.7",
    "@mui/toolpad-components": "0.1.20",
    "@mui/toolpad-core": "0.1.20",
    "@mui/toolpad-utils": "0.1.20",
    "@mui/types": "7.2.4",
    "@mui/utils": "5.13.7",
    "@mui/x-data-grid": "6.9.2",
    "@mui/x-data-grid-pro": "6.9.2",
    "@mui/x-date-pickers": "6.9.2",
    "@mui/x-date-pickers-pro": "6.9.2",
    "@next/bundle-analyzer": "13.4.9",
    "@tanstack/react-query": "4.29.19",
    "@tanstack/react-query-devtools": "4.29.19",
    "@types/cors": "2.8.13",
    "@types/node": "20.4.1",
    "@types/react-dev-utils": "9.0.11",
    "@vitejs/plugin-react": "4.0.2",
    "abort-controller": "3.0.0",
    "arg": "5.0.2",
    "basic-auth": "2.0.1",
    "chalk": "5.3.0",
    "chokidar": "3.5.3",
    "clsx": "1.2.1",
    "concurrently": "8.2.0",
    "cors": "2.8.5",
    "crypto-js": "4.1.1",
    "csstype": "3.1.2",
    "dayjs": "1.11.9",
    "dotenv": "16.3.1",
    "esbuild": "0.18.11",
    "execa": "7.1.1",
    "express": "4.18.2",
    "find-up": "6.3.0",
    "fractional-indexing": "3.2.0",
    "get-port": "7.0.0",
    "glob": "10.3.3",
    "google-auth-library": "8.9.0",
    "history": "5.3.0",
    "http-proxy-middleware": "2.0.6",
    "invariant": "2.2.4",
    "json-to-ts": "1.7.0",
    "json5": "2.2.3",
    "latest-version": "7.0.0",
    "lodash-es": "4.17.21",
    "markdown-to-jsx": "7.2.1",
    "mime": "3.0.0",
    "mysql2": "3.5.0",
    "nanoid": "4.0.2",
    "next": "13.4.9",
    "node-fetch": "2.6.12",
    "node-fetch-har": "1.0.1",
    "open-editor": "4.0.0",
    "path-to-regexp": "6.2.1",
    "perf-cascade": "3.0.3",
    "pg": "8.11.1",
    "piscina": "4.0.0",
    "prettier": "2.8.8",
    "pretty-bytes": "6.1.0",
    "react": "18.2.0",
    "react-dev-utils": "12.0.1",
    "react-dom": "18.2.0",
    "react-error-boundary": "4.0.10",
    "react-hook-form": "7.45.1",
    "react-inspector": "5.1.1",
    "react-is": "18.2.0",
    "react-router-dom": "6.3.0",
    "react-split-pane": "0.1.92",
    "semver": "7.5.4",
    "serialize-javascript": "6.0.1",
    "ses": "0.18.4",
    "superjson": "1.12.4",
    "typescript": "5.1.6",
    "vite": "4.4.2",
    "vm-browserify": "^1.1.2",
    "whatwg-url": "13.0.0",
    "ws": "8.13.0",
    "yaml": "2.3.1",
    "yaml-diff-patch": "2.0.0",
    "yargs": "17.7.2",
    "zod": "3.21.4",
    "zod-validation-error": "1.3.1"
  },
  "devDependencies": {
    "@types/babel__code-frame": "7.0.3",
    "@types/crypto-js": "4.1.1",
    "@types/formidable": "3.4.0",
    "@types/glob": "8.1.0",
    "@types/har-format": "1.2.11",
    "@types/invariant": "2.2.35",
    "@types/lodash-es": "4.17.7",
    "@types/node-fetch": "2.6.4",
    "@types/pg": "8.10.2",
    "@types/prettier": "2.7.3",
    "@types/react": "18.2.14",
    "@types/react-dom": "18.2.6",
    "@types/react-inspector": "4.0.2",
    "@types/react-is": "18.2.1",
    "@types/serialize-javascript": "5.0.2",
    "@types/whatwg-url": "11.0.0",
    "@types/ws": "8.5.5",
    "ajv": "8.12.0",
    "eslint": "8.44.0",
    "eslint-config-next": "13.4.9",
    "eslint-config-prettier": "8.8.0",
    "eslint-plugin-import": "2.27.5",
    "formidable": "3.5.0",
    "get-port": "7.0.0",
    "monaco-editor": "0.40.0",
    "react-devtools-inline": "4.27.8",
    "react-transition-group": "4.4.5",
    "typescript": "5.1.6",
    "webpack": "5.88.1"
  },
  "typings": "./index.d.ts",
  "publishConfig": {
    "access": "public"
  },
  "gitHead": "08fb1bad6e60086d1b775f377101b88b3d1a9e5d"
}
